import { useState, useEffect, useRef } from 'react';
import { useUploadApi, useUploadActions } from '../actions';
import { useSelectedDeviceId } from '../selectors';
// https://developer.mozilla.org/fr/docs/Web/API/Media_Capture_and_Streams_API/Taking_still_photos
import { UploadIcon } from './icons';

const Photo = ({ limit = 200, onCapture = () => {}, mode = 'base64' }) => {
  const [error, setError] = useState('');
  const [devices, setDevices] = useState([]);
  const [hasStream, setHasStream] = useState(false);
  const videoRef = useRef(null);
  const { send } = useUploadApi();
  const { selectDeviceId } = useUploadActions();
  const selectedDeviceId = useSelectedDeviceId();

  useEffect(() => {
    const videoEl = videoRef.current;
    const filterVideoInputs = async () => {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((track) => track.stop());
      const devices = await navigator.mediaDevices.enumerateDevices();
      setDevices(devices.filter(({ kind }) => kind === 'videoinput'));
    };
    filterVideoInputs().catch(setError);
    return () => {
      videoEl?.srcObject?.getTracks().forEach((track) => track.stop());
    };
  }, []);

  useEffect(() => {
    if (videoRef.current?.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    setError('');
    if (!selectedDeviceId) {
      if (videoRef.current) {
        videoRef.current.srcObject = undefined;
      }
      setHasStream(false);
      return;
    }
    navigator.mediaDevices
      .getUserMedia({
        video: {
          deviceId: { exact: selectedDeviceId },
          // width: { ideal: 1280 },
        },
        /*
         *       {
         *         audio: false,
         *         facingMode: 'environment',
         *         // width: { min: 640, ideal: 640, max: 1920 },
         *         // height: { min: 400, ideal: 480 },
         *         // aspectRatio: 1.777777778,
         *         // frameRate: { max: 12 },
         *       },
         */
      })
      .then((stream) => {
        setHasStream(true);
        videoRef.current.srcObject = stream; // XXX
      })
      .catch((error) => {
        setHasStream(false);
        setError(error);
      });
  }, [selectDeviceId, selectedDeviceId]);

  const capture = () => {
    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    /*
       void ctx.drawImage(image, dx, dy);
       void ctx.drawImage(image, dx, dy, dLargeur, dHauteur);
       void ctx.drawImage(image, sx, sy, sLargeur, sHauteur, dx, dy, dLargeur, dHauteur);
       */
    canvas
      .getContext('2d')
      .drawImage(
        videoRef.current,
        0,
        0,
        canvas.width,
        canvas.height,
        0,
        0,
        canvas.width,
        canvas.height,
      );
    if (mode === 'file' || mode === 'send') {
      canvas.toBlob(function (blob) {
        const file = new File([blob], new Date().toISOString() + '.png', {
          type: 'image/png',
        });
        if (mode === 'file') {
          onCapture(file);
        }
        if (mode === 'send') {
          send(file);
        }
      }, /* toBlog */ 'image/png');
    } else {
      onCapture(canvas.toDataURL('image/png'));
    }
  };
  let maxWidth = limit;
  if (videoRef.current) {
    const { videoWidth, videoHeight } = videoRef.current;
    if (videoWidth && videoHeight && videoWidth > videoHeight) {
      maxWidth /= videoHeight / videoWidth;
    }
  }
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {devices.length > 0 && (
        <>
          <select
            value={selectedDeviceId}
            onChange={({ target }) => selectDeviceId(target.value)}
            style={{ padding: 8, fontSize: 16 }}
          >
            <option value=''>Caméra Off</option>
            {devices.map((device) => (
              <option
                key={device.deviceId}
                value={device.deviceId}
              >
                {device.label || 'Unnamed Camera'}
              </option>
            ))}
          </select>
          {error && <span>Vidéo indisponible : {error.message}</span>}
          <video
            ref={videoRef}
            autoPlay={true}
            style={{
              width: '100%',
              maxWidth,
              borderRadius: 8,
              height: hasStream ? 'auto' : 0,
            }}
          />
          {hasStream && (
            <div
              style={{
                position: 'absolute',
                bottom: '1.25rem',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              <button
                style={{
                  backgroundColor: '#EEEEEE',
                  border: 'none',
                  borderRadius: '0.5rem',
                  color: 'black',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  margin: '4px 2px',
                  padding: '0.5rem 1rem',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={capture}
              >
                {mode === 'send' ? <UploadIcon /> : '=0='}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Photo;
